import { z } from '@/utils/zod'

export const CostCenterSchema = z.object({
    number: z.number().min(1).max(99999999),
    label: z.string().min(1).max(64),
    bookable: z.boolean(),
})

export type CostCenter = z.infer<typeof CostCenterSchema>

export const CostCenterRegionSchema = z.object({
    digit: z.number().int().min(1).max(9),
    label: z.string().min(1).max(64),
    hasTax: z.boolean(),
})

export type CostCenterRegion = z.infer<typeof CostCenterRegionSchema>
